import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { addYears, format, getYear, isAfter } from 'date-fns';

@Component({
  selector: 'a-mat-calendar-month',
  templateUrl: './a-mat-calendar-month.component.html',
  styleUrls: ['./a-mat-calendar-month.component.scss'],
})
export class AMatCalendarMonthComponent implements OnInit {

  @Input() activeDate: Date;
  @Input() currentYear: number;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Output() onMonthClick: EventEmitter<Date> = new EventEmitter();
  @Output() onBackToYear: EventEmitter<Date> = new EventEmitter();

  monthList: { value: Date, isSelected: boolean }[] = [];

  previousBtnDisabled = false;
  nextBtnDisabled = false;

  constructor() { }

  ngOnInit(): void {
    this.minDate = new Date(format(this.minDate, "yyyy/MM/") + "01");
    this.maxDate = new Date(format(this.maxDate, "yyyy/MM/") + "01");
    this.calculateMonthRange(this.currentYear);
  }

  calculateMonthRange(currentYear: number) {
    this.monthList = [];
    for (let i = 1; i <= 12; i++) {
      const d = new Date(currentYear + "/" + i + "/01");
      this.monthList.push({
        value: d,
        isSelected: format(d, "yyyy/MM") === format(this.activeDate, "yyyy/MM")
      });
    }

    this.checkButtonsCanBeClick();
  }

  previousMonthList() {
    this.currentYear -= 1;

    this.calculateMonthRange(this.currentYear);
    this.checkButtonsCanBeClick();
  }

  nextMonthList() {
    this.currentYear += 1;
    this.calculateMonthRange(this.currentYear);
    this.checkButtonsCanBeClick();
  }

  checkButtonsCanBeClick() {

    const startMonth = this.monthList[0].value, endMonth = this.monthList[this.monthList.length - 1].value;

    if (isAfter(this.minDate, startMonth)) {
      this.previousBtnDisabled = true;
    } else {
      this.previousBtnDisabled = false;
    }

    if (isAfter(endMonth, this.maxDate)) {
      this.nextBtnDisabled = true;
    } else {
      this.nextBtnDisabled = false;
    }
  }

  monthClick(date: Date) {
    this.onMonthClick.emit(date);
  }

  backToYearList() {
    this.onBackToYear.emit(this.monthList[0].value);
  }
}
